import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { formatMoney } from '../../../../../utils/money';
import { ValorizationInfo } from '../../../types/billing.types';

interface ValorizationInfoDialogProps {
  info: ValorizationInfo;
  onClose: () => void;
}

/** "Información de la valorización" ({@code ContractInfoValorizationWindow}): solo lectura. */
export default function ValorizationInfoDialog({ info, onClose }: ValorizationInfoDialogProps) {
  return (
    <Dialog
      header="Información de la valorización"
      visible
      onHide={onClose}
      className="nv-scope nv-dialog"
      modal
      draggable={false}
      footer={<Button type="button" className="buttonMain" label="Cerrar" onClick={onClose} />}
    >
      <div className="nv-dialog-body">
        <section className="nv-section" aria-labelledby="info-benefit-title">
          <h3 id="info-benefit-title" className="nv-section-title">Prestación</h3>
          <p className="nv-ro-value">{info.benefit}</p>
        </section>
        <section className="nv-section" aria-labelledby="info-contract-title">
          <h3 id="info-contract-title" className="nv-section-title">Convenio</h3>
          <dl className="nv-summary-grid">
            {info.contract.map((entry) => (
              <div key={entry.label} className="nv-ro">
                <dt className="nv-ro-label">{entry.label}</dt>
                <dd className="nv-ro-value">{entry.value || '—'}</dd>
              </div>
            ))}
          </dl>
        </section>
        <section className="nv-section" aria-labelledby="info-value-title">
          <h3 id="info-value-title" className="nv-section-title">Valorización</h3>
          <p className="nv-ro-value">
            {info.unitPrice != null ? formatMoney(info.unitPrice) : '—'}
            {info.calculateMode ? ` (${info.calculateMode})` : ''}
          </p>
          {info.practiceUnits.length > 0 && <p className="nv-help">{info.practiceUnits.join(' + ')}</p>}
        </section>
        {info.differentials.length > 0 && (
          <section className="nv-section" aria-labelledby="info-differential-title">
            <h3 id="info-differential-title" className="nv-section-title">Diferencial</h3>
            <ul className="nv-stack-4">
              {info.differentials.map((text) => <li key={text}>{text}</li>)}
            </ul>
          </section>
        )}
      </div>
    </Dialog>
  );
}
